<div [class]="getCssClasses()">

  <div class="card-body-height">

    @if (cardTitle !== null) {
      <div class="card-header">
        <h2>{{cardTitle}}</h2>
      </div>
    }

    <div [class]="getBodyCssClasses()" [style.textAlign]="'left'">
      @if (!isLoading) {
        <ng-content select="[data-body]"></ng-content>
      } @else {
        <t4-loader></t4-loader>
      }
    </div>


  </div>

  @if (showFooter) {
    <div class="card-footer" style="min-height: 24px;">
      <div><ng-content select="[data-footer-left]"></ng-content></div>
      <div><ng-content select="[data-footer-right]" fxLayoutAlign="flex-end"></ng-content></div>
    </div>
  }

</div>
